import { DbCenterBaseApiV2 } from "../../DbCenterBaseApiV2";

export class ModuleScriptApi extends DbCenterBaseApiV2 {

    public get ControllerName(): any {
        return 'moduleScript';
    }

}